(function () {
  if (window.refreshQuickCartFull) return;

  var refreshTimer = null;
  var refreshPromise = null;

  function getWrapper() {
    return document.querySelector('.quick-cart__wrapper');
  }

  function getContainer() {
    return document.querySelector('.quick-cart__container');
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-js-cart-count], .quick-cart__heading sup').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function applyShippingBarProgress(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var bars = document.querySelectorAll('.quick-cart [data-free-shipping-bar], .quick-cart .free-shipping-bar');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var cartTotal = cart.total_price;
      bar.setAttribute('data-cart-total', String(cartTotal));
      bar.dataset.cartTotal = String(cartTotal);

      var thresholdRaw = parseFloat(bar.dataset.threshold || '45');
      var thresholdCents = thresholdRaw > 1000 ? thresholdRaw : Math.round(thresholdRaw * 100);
      var qualified = cartTotal >= thresholdCents;
      var progress = thresholdCents > 0 ? Math.min(100, (cartTotal / thresholdCents) * 100) : 100;
      var progressValue = progress + '%';

      bar.classList.add('free-shipping-bar--loaded');
      bar.classList.toggle('free-shipping-bar--success', qualified);
      bar.classList.toggle('free-shipping-bar--pending', !qualified);
      bar.style.setProperty('--progress-width', progressValue);

      var message = bar.querySelector('.free-shipping-bar__message');
      if (message) {
        if (qualified) {
          message.innerHTML = bar.dataset.freeShippingSuccessMessage || 'Free shipping unlocked!';
        } else {
          var remaining = Math.max(thresholdCents - cartTotal, 0);
          var money = '$' + (remaining / 100).toFixed(2);
          var pending = bar.dataset.freeShippingPendingMessage || 'Only {{ remaining_amount }} away from FREE SHIPPING!';
          message.innerHTML = pending.replace('{{ remaining_amount }}', '<span class="fs-body-bold">' + money + '</span>');
        }
      }

      var track = bar.querySelector('.free-shipping-bar__bar');
      var fill = bar.querySelector('.free-shipping-bar__bar-progress');
      if (track) {
        track.style.setProperty('--progress-width', progressValue);
        track.setAttribute('style', (track.getAttribute('style') || '').replace(/--progress-width:\s*[^;]+;?/g, '') + '--progress-width: ' + progressValue + '; display: block; opacity: 1; visibility: visible;');
      }
      if (fill) {
        fill.style.setProperty('--progress-width', progressValue);
        fill.style.setProperty('width', progressValue, 'important');
        fill.style.display = 'block';
        fill.style.opacity = '1';
        fill.style.visibility = 'visible';
      }
    });
  }

  function updateShippingBar(cart) {
    if (!cart) return;
    window.__lastCartJson = cart;
    applyShippingBarProgress(cart);
    if (typeof window.updateFreeShippingBar === 'function') {
      window.updateFreeShippingBar(cart);
    }
  }

  function syncShippingBarFromCart() {
    return fetch('/cart.js?t=' + Date.now(), { cache: 'no-store', credentials: 'include' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        window.__lastCartJson = cart;
        updateShippingBar(cart);
        return cart;
      })
      .catch(function () {});
  }

  window.syncFreeShippingBarFromCart = syncShippingBarFromCart;

  function initSwiper(selector, options) {
    if (typeof window.Swiper === 'undefined') return;
    document.querySelectorAll(selector).forEach(function (slider) {
      if (slider.swiper) {
        try {
          slider.swiper.update();
          slider.swiper.updateSlides();
        } catch (e) {}
        return;
      }
      if (!slider.querySelector('.swiper-slide')) return;
      try {
        new window.Swiper(slider, options);
      } catch (e) {}
    });
  }

  function bootCartDrawerJs(cart) {
    window.__lastCartJson = cart || window.__lastCartJson;
    updateHeaderCount(window.__lastCartJson);
    updateShippingBar(window.__lastCartJson);

    requestAnimationFrame(function () {
      if (typeof window.triggerAllSlidersRefresh === 'function') {
        window.triggerAllSlidersRefresh(true);
      }
      if (typeof window.reinitOfferSlider === 'function') {
        window.reinitOfferSlider();
      }
      if (typeof window.initOfferSlider === 'function') {
        window.initOfferSlider();
      }

      setTimeout(function () {
        initSwiper('.quick-cart .cart-product-swiper', {
          spaceBetween: 10,
          slidesPerView: 2.2,
          watchOverflow: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.quick-cart .swiper-button-next',
            prevEl: '.quick-cart .swiper-button-prev'
          }
        });
        initSwiper('.quick-cart .offer-slider', {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          observer: true,
          observeParents: true
        });
        initSwiper('.quick-cart [data-cross-sells-slider].swiper, .quick-cart .cross-sells__items.swiper', {
          slidesPerView: 1.15,
          spaceBetween: 8,
          watchOverflow: true,
          grabCursor: true,
          observer: true,
          observeParents: true
        });
        updateShippingBar(window.__lastCartJson);
      }, 180);
    });
  }

  function runAjaxUpdate() {
    var wrapper = getWrapper();
    var liveContainer = getContainer();
    if (!liveContainer) return Promise.resolve();

    var wasOpen = !!(wrapper && wrapper.classList.contains('active'));
    window.__quickCartRefreshing = true;

    return Promise.all([
      fetch('/cart?section_id=quick-cart&t=' + Date.now(), { cache: 'no-store', credentials: 'include' }).then(function (res) {
        return res.text();
      }),
      fetch('/cart.js?t=' + Date.now(), { cache: 'no-store', credentials: 'include' }).then(function (res) {
        return res.json();
      })
    ])
      .then(function (results) {
        var html = results[0];
        var cart = results[1];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = doc.querySelector('.quick-cart__container');
        var currentContainer = getContainer();

        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        }

        if (wasOpen && wrapper) {
          wrapper.classList.add('active');
        }

        window.__lastCartJson = cart;
        bootCartDrawerJs(cart);
        return cart;
      })
      .catch(function (error) {
        console.error('Cart drawer AJAX update failed:', error);
      })
      .then(function (cart) {
        window.__quickCartRefreshing = false;
        refreshPromise = null;
        return cart;
      });
  }

  window.bootQuickCartJs = bootCartDrawerJs;

  window.refreshQuickCartFull = function () {
    clearTimeout(refreshTimer);

    if (refreshPromise) return refreshPromise;

    refreshPromise = new Promise(function (resolve) {
      refreshTimer = setTimeout(function () {
        resolve(runAjaxUpdate());
      }, 250);
    });

    return refreshPromise;
  };

  function scheduleShippingBarSync() {
    syncShippingBarFromCart();
    setTimeout(syncShippingBarFromCart, 250);
    setTimeout(syncShippingBarFromCart, 600);
    setTimeout(syncShippingBarFromCart, 1000);
  }

  ['quantity-update:add', 'quantity-update:subtract', 'quantity-update:remove', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, scheduleShippingBarSync);
  });

  document.addEventListener('click', function (event) {
    if (
      !event.target.closest(
        '.quick-cart [data-add-quantity], .quick-cart [data-subtract-quantity], .quick-cart [data-remove-item], .quick-cart .quick-cart__item-remove, .quick-cart .quantity-input__button'
      )
    ) {
      return;
    }
    scheduleShippingBarSync();
  });
})();